module.exports = __webpack_public_path__ + "img/loader.ea800168.gif";